import { useQuery } from '@tanstack/react-query';

import { ErrorMessage } from '../../components/ErrorMessage';
import { Hub } from '../../components/Hub';
import { PageLoader } from '../../components/Loader';
import { AreasTable, MaklerTable } from '../../ops/TeamTables';
import { useProject } from '../../projects/context';
import { projectKeys, useProjectApi } from '../../projects/useProjectApi';
import { AreasPage } from './AreasPage';
import { MaklerpassPartnerSection } from './MaklerpassPartnerHub';

// Gebiete & Makler: Steuerungsebene des Projekts – welcher Makler betreut welches Gebiet, wie viele Leads
// liegen dort, welche Termine und offenen Punkte gibt es. Dazu die Rubrik „Maklerpass Partner“ (Top-Bestandsmakler
// mit Sales & Auftrag erteilt, 1 je Gebiet, Neukunden-Sparte & Full-Service-Staffelmodell).
export function AreasHub() {
  return (
    <Hub
      title="Gebiete & Makler"
      description="Welcher Makler für welche Landkreise, Gemeinden und PLZ zuständig ist – plus Maklerpass Partner-Auswahl (Sales & Auftrag erteilt, max. 1 Partner je Gebiet)."
      label="Ansicht"
      tabs={[
        { key: 'uebersicht', label: 'Übersicht', render: () => <AreasOverview /> },
        {
          key: 'top-partner',
          label: 'Top-Bestandsmakler (Sales & Auftrag erteilt)',
          render: () => <MaklerpassPartnerSection initialTab="bestand" />,
        },
        {
          key: 'neukunden',
          label: 'Neukunden Maklerpass (Freie Gebiete)',
          render: () => <MaklerpassPartnerSection initialTab="neukunden" />,
        },
        {
          key: 'modell',
          label: 'Staffel- & Full-Service-Modell (~5 %)',
          render: () => <MaklerpassPartnerSection initialTab="modell" />,
        },
        { key: 'verwalten', label: 'Gebiete verwalten', render: () => <AreasPage embedded /> },
      ]}
    />
  );
}

function AreasOverview() {
  const { project } = useProject();
  const papi = useProjectApi();
  const team = useQuery({ queryKey: projectKeys.team(project.id), queryFn: ({ signal }) => papi.teamOverview(signal), refetchInterval: 120_000 });
  if (team.isPending) return <PageLoader />;
  if (team.isError) return <ErrorMessage error={team.error} onRetry={() => void team.refetch()} />;
  return (
    <>
      <section aria-labelledby="areas-title">
        <h2 id="areas-title">Gebiete</h2>
        <AreasTable areas={team.data.areas} />
      </section>
      <section aria-labelledby="makler-title">
        <h2 id="makler-title">Makler</h2>
        <MaklerTable fieldSales={team.data.field_sales} />
      </section>
    </>
  );
}
